export const getURLSearchParams = (): URLSearchParams => {
  return new URLSearchParams(window.location.search);
};

const buildURL = (params: URLSearchParams): string => `${window.location.pathname}?${params.toString()}`;

export const replaceURLState = (newParams: URLSearchParams): void => {
  window.history.replaceState(newParams, undefined, buildURL(newParams));
};

export const pushNewURLState = (newParams: URLSearchParams): void => {
  window.history.pushState(newParams, undefined, buildURL(newParams));
};

export const subscribeToURLStatePop = (handler: (poppedParams: URLSearchParams) => void): void => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
  window.onpopstate = (event: PopStateEvent) => handler(event.state);
};
